module.exports = __webpack_public_path__ + "img/vicente-cuellar.d908be84.jpg";